<template>
	<div class="buy-giftcard">
		<!-- <v-container tag="section" fluid constrain>
			<h1 :class="[$vuetify.breakpoint.smAndUp && 'display-2']">Aktiver gavekortet</h1>
		</v-container>-->

		<v-container tag="section" fluid constrain mb-12>
			<v-sheet :class="[$vuetify.breakpoint.mdAndUp ? 'pa-12' : 'pa-6']">
				<v-row :pa-6="$vuetify.breakpoint.mdAndUp">
					<!-- Title and information -->
					<v-col cols="12" sm="5" :pr-12="$vuetify.breakpoint.mdAndUp">
						<icon-title :src="icon" :width="$vuetify.breakpoint.mdAndUp ? 250 : 150" :size="$vuetify.breakpoint.mdAndUp ? '3rem' : '2rem'">Aktiver gavekort</icon-title>

						<p :class="[$vuetify.breakpoint.mdAndUp && 'lead pr-12']">
							Etter aktivering er du klar for å ta i bruk ditt Fixit.no-gavekort. Gavekortet kan brukes i over 700 frisør- og velværesalonger, og du finner salong og bestiller time på
							<a style="color:grey; text-decoration:none" href="https://fixit.no">Fixit.no</a>
						</p>
					</v-col>

					<transition name="scroll-y-transition" mode="out-in">
						<!-- Buy giftcard -->
						<v-col sm="7" key="buying" v-if="!isCompleted" style="position: relative">
							<!-- <div>
                <h2>Slik aktiverer du</h2>
                <p>
                  Finn fram gavekortet du har mottatt og skriv inn koden som står på kortet. Vi bruker ditt mobilnummer for å vite hvem som har aktivert gavekortet. Følg stegene under for å aktivere.
                </p>
							</div>-->
							<v-stepper v-model="currentStep" vertical class="buy-giftcard-steps elevation-0" color="primary">
								<!-- #1: Buyer and receiver info -->
								<v-stepper-step step="1" id="activate-giftcard-step-1" :complete="currentStep > 1" @click="goToStep(1)" class="pointer">
									Gavekort og mobil
									<small class="mt-1">Finn gavekortnummer under kortets strekkode</small>
								</v-stepper-step>
								<!-- Step1 content -->
								<v-stepper-content step="1">
									<enter-giftcard-number v-model="currentStep" :giftcard.sync="giftcard" />
								</v-stepper-content>

								<!-- #2: Giftcard options -->
								<v-stepper-step step="2" id="activate-giftcard-step-2" :complete="currentStep > 2">
									SMS-kode
									<small class="mt-1">Skriv inn engangskode mottatt på SMS</small>
								</v-stepper-step>

								<v-stepper-content step="2">
									<enter-sms-code v-model="currentStep" :giftcard.sync="giftcard" />
								</v-stepper-content>

								<!-- #3: Activated -->
								<v-stepper-step step="3" id="activate-giftcard-step-3" :complete="currentStep > 3">
									Gavekort aktivert
									<small class="mt-1"></small>
								</v-stepper-step>

								<v-stepper-content step="3">
									<activation-complete v-model="currentStep" :giftcard.sync="giftcard" />
								</v-stepper-content>
							</v-stepper>

							<v-overlay absolute :value="!!loading">
								<v-progress-circular indeterminate size="64"></v-progress-circular>
							</v-overlay>
						</v-col>
					</transition>
				</v-row>
			</v-sheet>
		</v-container>
	</div>
</template>

<script>
import IconTitle from '@/components/IconTitle';

// Buy giftcard step components
import EnterGiftcardNumber from './components/activate-giftcard/EnterGiftcardNumber';
import EnterSmsCode from './components/activate-giftcard/EnterSMSCode';
import ActivationComplete from './components/activate-giftcard/ActivationComplete';

// Payment components

export default {
	name: 'activate-giftcard-view',
	components: {
		IconTitle,
		EnterGiftcardNumber,
		EnterSmsCode,
		ActivationComplete
	},
	data() {
		return {
			currentStep: 1,
			giftcard: null,
			icon: require('@/assets/img/app-icon.png'),
			loading: 0
		};
	},
	computed: {
		isCompleted() {
			return this.currentStep == -1;
		}
	},
	methods: {
		goToStep(step) {
			// make sure we dont allow to step longer than possible/valid
			if (this.currentStep > step) {
				this.currentStep = step;
			}
		}
	},
	watch: {
		// Make sure we display the current step inside the viewport
		currentStep: function(step) {
			setTimeout(function() {
				if (step > 0) {
					const menuHeight = 80;
					const element = document.getElementById('activate-giftcard-step-' + step);
					const elementOffsetTop = element.getBoundingClientRect().top;
					let offsetTop = (offsetTop = Math.abs(elementOffsetTop + window.scrollY) - menuHeight);
					window.scrollTo({
						top: offsetTop,
						left: 0,
						behavior: 'smooth'
					});
				}
			}, 600);
		}
	}
};
</script>

<style lang="scss" scoped>
.pointer {
	cursor: pointer;
}
</style>
